import { LoadState } from '@trimble/data-loading';
import { GaussianSplatItem } from './DataStateModels';
import {
  GaussianSplatListEntry,
  GaussianSplatQuerySnapshot,
  GaussianSplatQueryUpdate,
} from './build-gaussian-splat-list-items.types';

/**
 * Rebuilds the splat list from an API response without dropping viewer load
 * state. A list refetch must not mark splats that are still in the 3D pane
 * as `NotLoaded`.
 */
export function buildGaussianSplatListItems(
  splats: readonly GaussianSplatListEntry[],
  existingItems: Readonly<Record<string, GaussianSplatItem>> | undefined
): Record<string, GaussianSplatItem> {
  return splats.reduce<Record<string, GaussianSplatItem>>((acc, splat) => {
    acc[splat.id] = {
      id: splat.id,
      name: splat.name,
      datasetId: splat.datasetId,
      loadState: existingItems?.[splat.id]?.loadState ?? LoadState.NotLoaded,
    };
    return acc;
  }, {});
}

export function resolveGaussianSplatQueryUpdate(
  query: GaussianSplatQuerySnapshot | undefined,
  existingItems: Readonly<Record<string, GaussianSplatItem>> | undefined
): GaussianSplatQueryUpdate {
  if (query == null) {
    return { kind: 'cleared' };
  }

  if (query.isError) {
    return { kind: 'failed' };
  }

  if (query.isLoading) {
    return { kind: 'loading' };
  }

  return {
    kind: 'ready',
    items: buildGaussianSplatListItems(query.data ?? [], existingItems),
  };
}
